export default "__VITE_ASSET__BOzrhxLS__"